import React, { useContext, useEffect, useState } from 'react';
import '../assets/css/admin/adminlayout/adminlayout.css';

import BuyerHeader from 'components/Buyer/buyerheader/BuyerHeader';
import BuyerSideBar from 'components/Buyer/buyersidebar/BuyerSideBar';
import AppContext from 'context/AppContext';

const BuyerMasterLayout = ({ children, pageTitle = 'Dashboard' }) => {
  
  // const [isSidebarExpanded, setIsSidebarExpanded] = useState(true);
  const {setAuthToken, setLoggedInBuyer}=useContext(AppContext);
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(
  JSON.parse(localStorage.getItem('sidebarExpanded')) ?? true
);

const handleSidebarToggle = () => {
  const newState = !isSidebarExpanded;
  setIsSidebarExpanded(newState);
  localStorage.setItem('sidebarExpanded', JSON.stringify(newState));
};

useEffect(()=>{
  const authToken = localStorage.getItem('authToken');
  setAuthToken(authToken);
  setLoggedInBuyer(JSON.parse(localStorage.getItem("loggedInBuyer")));
  
},[]);

  // ==========================================
  // RENDER - Complete Dashboard Layout
  // ==========================================
  
  return (
    <div className="admindashboard-layout">
      
      {/* SIDEBAR - Pass toggle handler */}
      <BuyerSideBar 
        isCollapsed={!isSidebarExpanded}
        onToggle={handleSidebarToggle}
      />

      {/* MAIN CONTENT AREA - Adjusts with sidebar */}
      <div className={`admindashboard-main ${isSidebarExpanded ? 'adminmain-expanded' : 'adminmain-collapsed'}`}>
        
        {/* HEADER - Pass sidebar state */}
        <BuyerHeader
          pageTitle={pageTitle}
          isSidebarExpanded={isSidebarExpanded}
        />

        {/* CONTENT AREA - Children rendered here */}
        <main className="admindashboard-content">
          {children}
        </main>

      </div>
    </div>
  );
};

export default BuyerMasterLayout;